import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgIconMylistFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group 5314",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Vector 241",
				d: "M19.8243 15.1757L15.1757 19.8243C15.0632 19.9368 14.9106 20 14.7515 20H1.2C0.537258 20 0 19.4627 0 18.8V1.2C0 0.537258 0.53726 0 1.2 0H18.8C19.4627 0 20 0.537258 20 1.2V14.7515C20 14.9106 19.9368 15.0632 19.8243 15.1757Z",
				fill: "#FEF08A"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector 240",
				d: "M14.6 14L19 14L14 19L14 14.6C14 14.2686 14.2686 14 14.6 14Z",
				fill: "#FACC15"
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "MY",
				children: [/* @__PURE__ */ _jsx("path", {
					id: "Vector",
					d: "M14.6865 11.988C14.6865 12.46 14.3105 12.748 13.8465 12.748C13.3745 12.748 13.0065 12.46 13.0065 11.988L13.0225 9.74798L11.0225 6.88398C10.9185 6.73998 10.8625 6.55598 10.8625 6.37998C10.8625 6.12398 10.9665 5.86798 11.1825 5.69998C11.3345 5.58798 11.5185 5.53198 11.7025 5.53198C11.9345 5.53198 12.1585 5.61998 12.3185 5.82798L13.8385 7.94798L15.3585 5.82798C15.5265 5.62798 15.7505 5.53198 15.9825 5.53198C16.1665 5.53198 16.3426 5.58798 16.4946 5.69998C16.7106 5.86798 16.8145 6.12398 16.8145 6.37998C16.8145 6.55598 16.7586 6.73998 16.6546 6.88398L14.6865 9.69998V11.988Z",
					fill: "#EAB308"
				}), /* @__PURE__ */ _jsx("path", {
					id: "Vector_2",
					d: "M7.59936 9.74799C7.35936 10.02 7.11936 10.148 6.87936 10.148C6.63136 10.148 6.39136 10.012 6.16736 9.74799L5.10336 8.53199V12.02C5.10336 12.396 4.79136 12.756 4.28736 12.756C3.79936 12.756 3.49536 12.396 3.49536 12.02V6.25199C3.49536 5.87599 3.79936 5.52399 4.28736 5.52399C4.55136 5.52399 4.83136 5.65199 5.00736 5.85199L6.88736 8.03599L8.75136 5.85199C8.91136 5.65999 9.21536 5.52399 9.47936 5.52399C9.87936 5.52399 10.2634 5.78799 10.2634 6.25199V12.02C10.2634 12.396 9.95136 12.756 9.44736 12.756C8.95936 12.756 8.65536 12.396 8.65536 12.02V8.53199L7.59936 9.74799Z",
					fill: "#EAB308"
				})]
			})
		]
	})
});
export default SvgIconMylistFill;
